import { t } from '../../i18n/t';

const LOCALES = ['en','de','fr','it','hu'];
const TYPE_KEYS = ['email','url','number','integer','digits','alphanum'];
const MSG_KEYS  = [
  'notblank','required','pattern','min','max','range',
  'minlength','maxlength','length','mincheck','maxcheck',
  'check','equalto'
];

window.ParsleyConfig = window.ParsleyConfig || {};
window.ParsleyConfig.i18n = window.ParsleyConfig.i18n || {};

LOCALES.forEach(locale => {
  const msgs = {
    defaultMessage: t('parsley.default_message', locale),
    type: Object.fromEntries(
      TYPE_KEYS.map(k => [k, t(`parsley.type.${k}`, locale)])
    ),
    ...Object.fromEntries(
      MSG_KEYS.map(k => [k, t(`parsley.${k}`, locale)])
    )
  };

  window.ParsleyConfig.i18n[locale] = Object.assign(
    {},
    window.ParsleyConfig.i18n[locale],
    msgs
  );

  // If file is loaded after Parsley main file, auto-load locale
  if (window.ParsleyValidator) {
    window.Parsley.addCatalog(
      locale,
      window.ParsleyConfig.i18n[locale],
      true
    );
  }
});
